<template>
    <v-row class="mx-12">
        <v-spacer></v-spacer>
        <v-col class="pt-0" cols="7">
            <v-card class="green lighten-4 pa-6 mx-auto elevation-12">
                <v-card-title class="justify-center">
                    <v-layout align-center>
                        <v-flex class="">
                            <div class="teal--text display-2 font-weight-bold text-center">기본대여자격</div>
                            <div class="teal--text subtitle-1 text-center">만 26세 이상 운전 면허 취득 3년이상인지에 한하여 대여 가능합니다.</div>
                            <div class="teal--text subtitle-1 text-center">승합차량 11인승차량은  1종 면허소지자에 한하여 대여 가능합니다.</div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-expansion-panels>
                  <v-expansion-panel>
                      <v-expansion-panel-header class="title font-weight-bold">예약전 차량확인</v-expansion-panel-header>
                      <v-expansion-panel-content>
                          <ul>
                              <li class="ml-5 body-1">원하시는 날짜에 차량대여 가능여부 확인통화.</li>
                              <li class="ml-5 body-1">고객님께서 원하시는 날짜에 차량 이용가능 여부를</li>
                              <li class="ml-5 body-1">고객센터를 통해 확인합니다.</li>
                          </ul>
                      </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                      <v-expansion-panel-header class="title font-weight-bold">입금하기</v-expansion-panel-header>
                      <v-expansion-panel-content>
                          <ul>
                              <li class="ml-5 body-1">대여일자와 요금확인 후 예약금 입금하기</li>
                              <li class="ml-5 body-1">차량 이용가능여부가 확인되었으면 예약금을 입금합니다. (전액 또는 대여료의 50%)</li>
                          </ul>
                      </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                      <v-expansion-panel-header class="title font-weight-bold">입금확인</v-expansion-panel-header>
                      <v-expansion-panel-content>
                          <ul>
                              <li class="ml-5 body-1">예약금 입금 후 확인통화(꼭 연락주세요)</li>
                              <li class="ml-5 body-1">입금확인 및 세부 시간예약 접수를 위해 고객센터로 확인합니다.</li>
                              <li class="ml-5 body-1">(통화가 안되면 예약접수가 되지 않습니다.)</li>
                          </ul>
                      </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                      <v-expansion-panel-header class="title font-weight-bold">차량인수</v-expansion-panel-header>
                      <v-expansion-panel-content>
                          <ul>
                              <li class="ml-5 body-1">면허증 지참 후 이용날짜에 대여차량인수</li>
                              <li class="ml-5 body-1">대여당일 면허증 지참후 본사로 방문하여</li>
                              <li class="ml-5 body-1">계약서 및 차량확인 후 차량을 인수받습니다.</li>
                          </ul>
                      </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </v-col>
        <v-spacer></v-spacer>
    </v-row>
</template>

<script>
export default {
  name: 'ShorttermRequirements',
  data: () => ({
  }),
};
</script>

<style scoped>
</style>
